import { configureStore } from '@reduxjs/toolkit';
import { commonReducer as common } from '@socialive/common';
import { featuresListeners, featuresReducer as features } from '@socialive/features';
import { modalsReducer as modals } from '@socialive/modals';
import { preferencesReducer as preferences } from '@socialive/preferences';
import { uploadsReducer as uploads } from '@socialive/uploads';
import { splitReducer as splitio } from '@splitsoftware/splitio-redux';
import accountInfo from './accountInfo';
import connectionManager from './connectionManager';
import env, { envListeners } from './env';
import { epicMiddleware, startEpicMiddleware } from './epics';
import joinBroadcast from './joinBroadcast';
import listeners from './listeners';
import logRocketMiddleware from './logRocketMiddleware';
import mediaUpload from './mediaUpload';
import { preferencesListeners } from './preferences';
import recordings from './recordings';
import sso from './sso';

export default configureStore({
  reducer: {
    accountInfo,
    common,
    connectionManager,
    env,
    features,
    joinBroadcast,
    mediaUpload,
    modals,
    preferences,
    recordings,
    splitio,
    sso,
    uploads,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(envListeners)
      .prepend(...Object.values(featuresListeners))
      .prepend(preferencesListeners)
      .prepend(listeners)
      .concat(epicMiddleware, logRocketMiddleware),
});

export * from './accountInfo';
export * from './common';
export * from './connectionManager';
export * from './env';
export * from './mediaUpload';
export * from './recordings';

startEpicMiddleware();
